export default __webpack_public_path__ + "static/media/Dealeradmin.cbb8cce1.png";